import { normalizeRoleCodeToken } from "./audit-token-normalizers.js";
import { resolveRoleCodeFromUserRoleSlot } from "./resolve-role-code-from-user-role-slot.js";

/** @typedef {import("../../../../user/model/user-role.type.js").UserRole} UserRole */

/**
 * Aliases normalizados por escopo de auditoria (`name` / `role_code`).
 * @type {Record<string, string[]>}
 */
const AUDIT_SCOPE_ALIASES = {
  comercial_opec: ["comercial_opec"],
  gerente_comercial: ["gerente_comercial"],
  financeiro: ["financeiro"],
  master: ["master", "admin"],
};

/**
 * Escopos de auditoria alinhados ao backend (role.name + actions).
 * @param {UserRole[]|unknown} roles
 * @param {string} scope — comercial_opec | gerente_comercial | master | financeiro | role_code do grupo
 * @param {"islist"|"isinsert"} [action="islist"]
 * @returns {boolean}
 */
export function hasAuditScope(roles, scope, action = "islist") {
  if (!Array.isArray(roles) || !scope) {
    return false;
  }

  const normalizedScope = normalizeRoleCodeToken(scope);
  if (!normalizedScope) {
    return false;
  }

  const aliases = AUDIT_SCOPE_ALIASES[normalizedScope] ?? [normalizedScope];
  const flagKey = action === "isinsert" ? "isinsert" : "islist";

  return roles.some((role) => {
    if (!role || typeof role !== "object") {
      return false;
    }

    const code = resolveRoleCodeFromUserRoleSlot(role);
    if (!aliases.includes(code)) {
      return false;
    }

    return Boolean(role[flagKey]);
  });
}
